import { render, staticRenderFns } from "./GroupAssignmentModal.vue?vue&type=template&id=8c71d6c8&"
import script from "./GroupAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./GroupAssignmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports